import { guidEmpty } from 'utils/guid-empty';
export class AlterarSenhaModel {
  constructor(
    public id: string = guidEmpty(),
    public senhaAtual: string = "",
    public senhaNova: string = "",
    public senhaConfirmacao = ""
  ) {}
}
